import type { MediaEntry } from './mediaEntries';

export const downloadEntriesAsZip = async (
  projectId: number,
  entries: MediaEntry[],
  trigger: (args: { projectId: number; paths: string[] }) => Promise<Blob>,
  downloadName = 'multimedia.zip'
) => {
  const paths = entries.map((e) => e.bucketFilePath).filter(Boolean);
  if (paths.length === 0) return;
  const blob = await trigger({ projectId, paths });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = downloadName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const triggerBlobDownload = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
